import React from 'react';
import { useAppSelector } from "../../../../store/hooks";
import { WorldInterface } from "../../../../store/mods_factory/worldsSlice";
import { selectCategoryEntities } from "../../../../store/mods_factory/categoriesSlice";

import { RightSidebar } from "../../../_partials/Layout";
import ListVertical from "../../../../componets/ListVertical";
import ListItem from "../../categories/_partials/_ListItem";
import {EntityId} from "@reduxjs/toolkit";

const _SidebarShow = ({ world }: { world: WorldInterface | undefined }) => {
  const categories = useAppSelector(selectCategoryEntities);

  const renderCategory = (id: EntityId) => {
    const category = categories[id];

    if (!category) {
      return null;
    }

    return <ListItem key={id} category={category} />;
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      <h6 className="v-content-label o-sm">Categories</h6>
      <ListVertical>
        {world?.category_ids.map(renderCategory)}
      </ListVertical>
    </RightSidebar>
  )
}

export default _SidebarShow;
